module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-3.webp?8b32e564";